import OnlineDialog from './onlineDialog';
import Loading from './loading';
import Time from './time';
import Plat from './plat';
import IsNew from './isNewStudent';
import Welcome from './welcome';
import { getOpenId } from './openId';
import { Api, Codes } from 'api';
import Download from './download';
import $gio from './gio';
import Login from 'utils/login';
import OnlineNoticeDialog from '@/components/OnlineNoticeDialog/main.js';
import $ddl from 'utils/ddl';
import $volc from 'utils/track/volcengine';
import $track from 'utils/track';
import $permission from 'utils/permission';
import { Message } from 'element-ui';
import { copy } from 'utils/Clipboard';

const $isNew = new IsNew();
const $time = new Time();
const $webfont = window.$webfont;
const downloadOSS = (url, name) => {
  return `/api/oss/download-as-name?url=${url}&name=${name}`;
};
const $online = new OnlineDialog();
const $loading = new Loading();
export const copyUrl = url => {
	return copy(url).then(() => {
		Message.success("已复制链接，请在浏览器打开");
	}).catch(() => {
		Message.error("复制链接失败");
	});
};
const $mountedRob = () => {
  return;
  // $webfont.submit();
};
const $locationReplace = (href, timeout = 0) => {
  const locationReplace = () => {
    if (history.replaceState) {
      history.replaceState({}, '', href);
      location.reload();
    } else {
      location.replace(href);
    }
  };
  setTimeout(() => {
    locationReplace();
  }, timeout);
};
const $location = (href, timeout = 0) => {
	if (Plat.isMiniProgram() && /^https?:\/\//.test(href)) {
		return copyUrl(href);
	}
  setTimeout(() => {
    window.location.href = href;
  }, timeout);
};

const $windowOpen = href => {
	if (Plat.isMiniProgram() && /^https?:\/\//.test(href)) {
		return copyUrl(href);
	}
  if (Plat.isMiniProgram() || Plat.isWeiXin()) {
    window.location.href = href;
  } else {
    // 底层浏览器实现必须调用原生 window.open。
    window.open(href);
  }
};
const $isWeiXin = Plat.isWeiXin();
const $isMobile = Plat.isMobile();
const $isMiniProgram = Plat.isMiniProgram();
const $welcome = new Welcome();
export default {
  $mountedRob,
  $location,
  $locationReplace,
  $windowOpen,
  $reload: () => {
    window.location.reload();
  },
  $webfont,
  downloadOSS,
  $loading,
  $time,
  $isMobile,
  $isWeiXin,
  $isMiniProgram,
  $online,
  $isNew,
  $welcome,
  $api: Api,
  $code: Codes,
  $openId: getOpenId,
  $download: Download.downloadFile,
  $onlineNoticeDialog: new OnlineNoticeDialog(),
  $gio,
  $login: Login,
  $teacher: Login.teacher,
  $school: Login.school,
  $student: Login.student,
  $sl: Login.sl,
  $ddl,
  isDeveloper: localStorage.getItem('whosyourdaddy'),
  isShowDeveloperView: localStorage.getItem('cheatmode'),
  isTester: localStorage.getItem('website-tester') || location.href.indexOf('password=whosyourdaddy') > -1,
  isTestSite:
    window.location.host !== 'www.hsylc.cn' &&
    window.location.host !== 'testamc.hsylc.cn' &&
    window.location.host !== 'chinaamc.hsylc.cn' &&
    window.location.host !== 'origin-www.hsylc.cn' &&
    window.location.host !== '172.18.1.39:2030',
  isAMCUser: localStorage.getItem('amc-auth') || location.href.indexOf('password=whosyourdaddy') > -1,
  $volc,
  $track,
  $permission
};
